import { createContext, useContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);

    // 🔄 Benutzerdaten aus localStorage laden (z. B. nach einem Refresh)
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    // ✅ Login
    const login = (userData) => {
        setUser(userData);
        localStorage.setItem("user", JSON.stringify(userData));
    };

    // 🚪 Logout + optionaler Callback (z. B. um den Warenkorb zu leeren)
    const logout = (onLogoutCallback) => {
        setUser(null);
        localStorage.removeItem("user");

        if (typeof onLogoutCallback === "function") {
            onLogoutCallback();
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
